export default "__VITE_ASSET__728b32a4__"